import React from 'react';

export function ErrorFallback({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert" style={{ padding: '20px' }}>
      <h2>Application Error</h2>

      {/* 1. The main error message */}
      <h3 data-testid="error-details" style={{ color: 'red' }}>
        {error.message}
      </h3>

      {/* 2. The full stack trace (Files & Line Numbers) */}
      <p style={{ whiteSpace: 'pre-wrap', margin: '10px 0', color: '#555' }}>
        <summary style={{ cursor: 'pointer' }}>Show Stack Trace</summary>
        <pre
          style={{
            fontSize: '12px',
            background: '#f5f5f5',
            padding: '10px',
            overflowX: 'auto',
          }}
        >
          {error.stack}
        </pre>
      </p>

      <button
        onClick={resetErrorBoundary}
        style={{ padding: '8px 16px', marginTop: '10px' }}
      >
        Reload Page
      </button>
    </div>
  );
}
